export default from './Templates';



// WEBPACK FOOTER //
// ./src/containers/Templates/index.js